<template>
    <div>
        <p v-if="filters">
            Filtres : {{filters}}
        </p>

        <b-table v-show="data.length > 0" striped hover :items="data" :fields="[
            {
                key: column_name,
                label: 'Nom',
                thStyle: { width: '20%' }
            },
            {
                key: column_image_reference,
                label: 'Référence',
                tdStyle: { width: '15%' }
            },
            {
                key: 'result',
                label: 'Résultats',
                tdStyle: { width: '60%' }
            },
            {
                key: 'custom_column',
                label: '',
                tdStyle: { width: '5%' }
            },
        ]">
            <template v-slot:[`cell(${column_image_reference})`]="data">
                <img style="max-width: 100px" :src="data.item[column_image_reference]" />
            </template>
            <template v-slot:cell(result)="data">
                <div v-show="!data.item.list">
                    <div v-for="(image, idx) in data.item.result.slice(0, 5)" :key="idx" :style="'display: inline-block; background-color:' + (blacklist.includes(image.link.replace(/(.*\/\/.*?\/).*/, '$1')) ? 'rgba(255, 0, 0, 0.2)' : whitelist.includes(image.link.replace(/(.*\/\/.*?\/).*/, '$1')) ? 'rgba(0, 255, 0, 0.2)' : 'inherit')">
                        <b-button @click="setImage(image)" variant="link"><img :id="uid+'image_' + image.id" style="max-width: 100px" :src="image.url" /></b-button><br />
                        {{image.width}} x {{image.height}}<br />
                        {{image.source}}&nbsp;
                        <b-tooltip custom-class="long-tooltip" :target="uid+'image_' + image.id">
                            Url : {{image.url}}<br />
                            Titre : {{image.title}}<br />
                            Source : {{image.source}}<br />
                            Page: {{image.link}}<br />
                            Taille: {{image.width}} X {{image.height}}<br />
                            Position de la recherche: {{image.position}}<br />
                            Score: {{image.score}}
                        </b-tooltip>
                    </div>
                </div>
                <div v-show="data.item.list">
                    <div v-for="(image, idx) in data.item.result" :key="idx">
                        <b-button @click="setImage(image)" :id="uid+'imagel_' + image.id" variant="link" :style="'text-align:left; color:' + (blacklist.includes(image.link.replace(/(.*\/\/.*?\/).*/, '$1')) ? 'rgba(255, 0, 0)' : whitelist.includes(image.link.replace(/(.*\/\/.*?\/).*/, '$1')) ? 'rgba(0, 255, 0)' : 'inherit')">{{image.source}} - {{image.title}}</b-button><br />
                        <b-tooltip custom-class="long-tooltip" :target="uid+'imagel_' + image.id">
                            Url : {{image.url}}<br />
                            Titre : {{image.title}}<br />
                            Source : {{image.source}}<br />
                            Page: {{image.link}}<br />
                            Taille: {{image.width}} X {{image.height}}<br />
                            Position de la recherche: {{image.position}}<br />
                            Score: {{image.score}}
                        </b-tooltip>
                    </div>
                </div>
            </template>
            <template  v-slot:cell(custom_column)="data">
                <b-button v-if="!data.item.list" @click="setList(data.item, 'list', true)">Liste</b-button>
                <b-button v-else @click="setList(data.item, 'list', false)">Image</b-button>
            </template>
        </b-table>

        <b-modal ok-only :id="uid+'image'" title="Visualisation" size="xl">
            <b-container style="margin: 0; padding: 0; max-width: none" v-if="image">
                <b-row>
                    <b-col cols="5">
                        <div>Image de référence</div>
                        <img style="max-width: 100%; max-height: 500px" :src="image.ref" />
                    </b-col>
                    <b-col cols="7">
                        <div>Image</div>

                        <div v-if="image">
                            <img style="max-width: 100%; max-height: 500px" :src="image.url" />

                            <p>
                                Url : <pre>{{image.url}}</pre>
                                Titre : {{image.title}}<br />
                                Source : {{image.source}}<br />
                                Page: <a :href="image.link" target="_blank">{{image.link}}</a><br />
                                Taille: {{image.width}} X {{image.height}}<br />
                                Position de la recherche: {{image.position}}<br />
                                Score: {{image.score}}<br />
                            </p>

                            <b-button @click="add(image.link.replace(/(.*\/\/.*?\/).*/, '$1'), 'blacklist')">Ajouter en blacklist</b-button>&nbsp;
                            <b-button @click="add(image.link.replace(/(.*\/\/.*?\/).*/, '$1'), 'whitelist')">Ajouter en whitelist</b-button>&nbsp;
                            <b-button @click="add(image.link.replace(/(.*\/\/.*?\/).*/, '$1'), '')">Rendre neutre</b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>

    export default {
		components: {
        },
        props: {
            filters: {
                default: '',
                type: String
            },
            data: {
				default: () => []
            },
            whitelist: {
				default: () => []
            },
            blacklist: {
				default: () => []
            },
            column_image_reference: {
                default: '',
                type: String
            },
            column_name: {
                default: '',
                type: String
            },
            column_brand: {
                default: '',
                type: String
            }
        },
		data() {
			return {
                uid: this.$uuid.v4(),
                image: null
            }
        },
        methods: {
            setList(item, key, value)
            {
                this.$set(item, key, value);
            },
            setImage(image)
            {
                this.image = image;
                this.$bvModal.show(this.uid+"image")
            },
            add(element, type)
            {
                this.$emit("add", element, type, true, false);
            }
        },
		mounted: async function () {

        }
    }
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}

    .long-tooltip .tooltip-inner
    {
        max-width: 600px !important;
        text-align: left !important;
    }
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }

</style>